module.exports = __webpack_public_path__ + "static/img/2.b8b4275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/2.png
// module id = b+o+
// module chunks = 0